import { Button } from '@/components/Button'
import { InfiniteScrollLoaderContainer } from '@/components/InfiniteScrollLoader/InfiniteScrollLoaderContainer'
import { links } from '@/utils/link'
import { OpportunitiesListEmpty } from '@/features/opportunities/components/OpportunitiesListEmpty'
import { observer } from 'mobx-react-lite'
import { useFeatures } from '@/contexts/root-store-context'
import { type OpportunitiesViewModel } from '@/features/opportunities/OpportunitiesViewModel'
import { OpportunityListItemContainer } from '@/features/opportunities/components/Opportunities/OpportunitiesList/OpportunityListItem/OpportunityListItemContainer'
import { byDesign } from '@/infra/design'
import imgEmptyUrl from '@/assets/misc/img_empty.svg'
import LookingEmptyIllustration from '@/components/SpotIllustration/LookingEmptyIllustration'

export interface OpportunitiesListContainerProps {
  vm: OpportunitiesViewModel
}

export const OpportunitiesListContainer = observer(
  function OpportunitiesListContainer({ vm }: OpportunitiesListContainerProps) {
    return (
      <div>
        <div>
          {vm.opportunities.map((op) => (
            <OpportunityListItemContainer
              key={op.opportunity.id}
              opportunityVm={op}
              showWorkspaceInfo={vm.showWorkspaceInfo}
            />
          ))}
          {vm.showEmptyState && <OpportunitiesEmptyContainer vm={vm} />}
        </div>
        <InfiniteScrollLoaderContainer scrollProvider={vm.searcher.scroller} />
      </div>
    )
  },
)

interface OpportunitiesEmptyContainerProps {
  vm: OpportunitiesViewModel
}

const OpportunitiesEmptyContainer = observer(
  function OpportunitiesEmptyContainer({
    vm,
  }: OpportunitiesEmptyContainerProps) {
    const { shellInfo } = useFeatures(({ shell }) => ({
      shellInfo: shell.shellInfo,
    }))
    if (vm.isCompletelyEmpty) {
      return (
        <OpportunitiesListEmpty
          corporateMode={shellInfo.corporateMode}
          title="Looking a little empty? Get notified when new opportunities appear."
          imageSrc={imgEmptyUrl}
          illustration={byDesign(undefined, LookingEmptyIllustration)}
          subtitle={
            <>
              Make sure you have your notification preferences set up correctly.
            </>
          }
        >
          <Button
            label="Go To Notification Preferences"
            variant="primary"
            to={links.profileNotifications()}
          />
        </OpportunitiesListEmpty>
      )
    }

    return (
      <OpportunitiesListEmpty
        onClearSearchFilter={vm.searcher.clearFilters}
        corporateMode={shellInfo.corporateMode}
      />
    )
  },
)
